const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.215 21.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.107 3.107a1.64 1.64 0 0 0 0 2.322l5.178 5.178-5.178 5.178a1.64 1.64 0 0 0 0 2.323c.644.644 1.68.643 2.323 0l5.178-5.178 5.178 5.178a1.64 1.64 0 0 0 2.323 0 1.64 1.64 0 0 0-.001-2.322l-5.178-5.178 5.179-5.179a1.64 1.64 0 0 0 0-2.322 1.64 1.64 0 0 0-2.323 0l-5.18 5.178-5.178-5.178a1.637 1.637 0 0 0-2.321-.001",
    style: {
      strokeWidth: 10.0724
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.294dbdc53730d1b924e03d1762ec89a1.svg";
export { ForwardRef as ReactComponent };